import {Application} from 'pixi.js';

export class ContextMenuRemoveController
{
    /**
     * Убираем вызов стандартного контекстного меню системы
     * @param app - PIXI-контейнер
     */
    static start(app: Application): void {
        app.view.addEventListener('contextmenu', (e: MouseEvent) => {
            e.preventDefault();
        });
    }
}
